module.exports = __webpack_public_path__ + "media/images/spotify-podcast-b39ddadaba8a16f2f860d2a0757a4aaf.jpg";